export class DefaultAlgorithmConfiguration {
    algorithmName; // Behaves as type guard!
    affectedNodes;
    userGivenConfiguration;
    type;
    name;
    shouldCreateNewGraph;
    algorithmPhasesToCall;
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        if (algorithmPhasesToCall === undefined) {
            this.algorithmPhasesToCall = "PREPARE-AND-RUN";
        }
        else {
            this.algorithmPhasesToCall = algorithmPhasesToCall;
        }
        this.shouldCreateNewGraph = shouldCreateNewGraph;
        this.affectedNodes = affectedNodes;
        this.type = "ALG";
        this.userGivenConfiguration = userGivenConfiguration;
    }
    addAlgorithmConfiguration(key, value) {
        this.userGivenConfiguration[key] = value;
        this.addAlgorithmConfigurationToUnderlyingData(key, value);
    }
    addAdvancedSettings(advancedSettings) {
        if (this.userGivenConfiguration["advanced_settings"] === undefined) {
            this.userGivenConfiguration["advanced_settings"] = { ...advancedSettings };
        }
        else {
            this.userGivenConfiguration["advanced_settings"] = {
                ...this.userGivenConfiguration["advanced_settings"],
                ...advancedSettings,
            };
        }
        this.addAdvancedSettingsToUnderlyingData(advancedSettings);
    }
}
export class RandomConfiguration extends DefaultAlgorithmConfiguration {
    static getDefaultUserConfiguration() {
        return {
            layout_alg: "random",
            advanced_settings: {},
            run_layered_after: false,
            run_node_overlap_removal_after: true,
            interactive: false
        };
    }
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        super(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall);
        this.algorithmName = "random";
    }
    addAlgorithmConfigurationToUnderlyingData(key, value) {
        // EMPTY
    }
    addAdvancedSettingsToUnderlyingData(advancedSettings) {
        // EMPTY
    }
}
/**
 * General Class which has all relevant configurations for the stress like algorithm. The classes extending this should convert the user configurations
 *  into
 * the representation which will be used in the algorithm (that means renaming, transforming[, etc.] the parameters in the data field)
 */
export class StressConfiguration extends DefaultAlgorithmConfiguration {
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        super(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall);
    }
}
export class LayeredConfiguration extends DefaultAlgorithmConfiguration {
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        super(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall);
    }
}
// TODO: Maybe put each class to separate file?
// TODO: I am not sure if this actually adds anything - the extra abstract class before moving to the elk implementation
export class RadialConfiguration extends DefaultAlgorithmConfiguration {
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        super(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall);
    }
}
export class AutomaticConfiguration extends DefaultAlgorithmConfiguration {
    static getDefaultUserConfiguration() {
        return {
            layout_alg: "automatic",
            min_distance_between_nodes: 500,
            number_of_new_algorithm_runs: 1,
            advanced_settings: {},
            run_layered_after: false,
            run_node_overlap_removal_after: false,
            interactive: false
        };
    }
    addAlgorithmConfigurationToUnderlyingData(key, value) {
        // Do Nothing
    }
    addAdvancedSettingsToUnderlyingData(advancedSettings) {
        // Do nothing
    }
    constructor(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall) {
        super(userGivenConfiguration, affectedNodes, shouldCreateNewGraph, algorithmPhasesToCall);
        this.algorithmName = "automatic";
    }
}
//# sourceMappingURL=algorithm-configurations.js.map